<template>
  <div class="management_tree_group">
    <label class="tree_group">
      <input
        type="checkbox"
        @click="checkChange"
        :checked="checked"
      />
      <span>{{ group.name }}</span>
    </label>
    <img :src="row" alt="箭头" @click="groupChange" class="tree_row" />
    <div><slot name="tree-list"></slot></div>
  </div>
</template>

<script>
export default {
  name: "ManagementTreeGroup",
  data() {
    return {
      row: require("@/common/assets/right.png"),
      clickIndex: 0,
      isChecked: false,
    };
  },
  props: {
    group: {
      type: Object,
      default: () => {},
    },
    checked: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    groupChange() {
      this.$emit("groupChange");
    },
    checkChange(e) {
      // console.log(e.target.checked)
      this.$emit("checkChange", e);
    },
  },
};
</script>

<style lang="less" scoped>
.management_tree_group::after {
  content: "";
  clear: both;
  display: inline-block;
}
.management_tree_group {
  box-sizing: border-box;
  float: left;
  width: 94%;
  margin-left: calc(100% / 2 - 94% / 2);
}
.tree_group {
  position: relative;
  display: block;
  width: 90%;
  height: 55px;
  float: left;
  background-color: #fff;
  box-sizing: border-box;
  input {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-top: calc(55px / 2 - 20px / 2);
    float: left;
  }
  span {
    line-height: 55px;
    margin-left: 4px;
    font-size: 20px;
  }
}
.tree_row {
  float: right;
  width: 10px;
  height: 14px;
  margin-right: 10px;
  transform: rotate(90deg);
  margin-top: calc(55px / 2 - 14px / 2);
}
</style>


// WEBPACK FOOTER //
// src/components/groupManagement/ManagementTreeGroup.vue